// pages/LuxotticaLoginPage.jsx (or any page file)

import LoginPage from '@/components/LoginPage';
import config from '@/config';
import { buildPath } from '@/utils/routeBuilder';

const IconicLoginPage = () => {
  return (
    <LoginPage
      projectId="iconic"
      projectName="Iconic"
      registerPath={buildPath('/iconic/register')}
      forgotPasswordPath={buildPath('/iconic/forgot-password')}
      dashboardPath={buildPath('/iconic')}
      apiUrl={config.AUTH_API_ADDRESS}
      brandColor="red"
    />
  );
};

export default IconicLoginPage;